import React, { PureComponent } from 'react'

import { Http } from '../../../../../support';
import LoadingButton from '../../../../../facturotopia/LoadingButton';

class RecepcionItemActions extends PureComponent {
  state = {
    busy: false,
  }

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true
    });

    try {
      const params = {
        download: 1
      }

      const response = await Http.get(`${window.BONJOUR_URL}/api/recepcion/comprobantes/${this.props.data.id}`, { responseType: 'blob', params });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el archivo original'
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  render() {
    const { data } = this.props;
    const { busy } = this.state;

    const tipo = data.tipo.toUpperCase();

    return (
      <LoadingButton
        variant="secondary"
        loading={ busy }
        onClick={ this.handleOnDownloadActionClick }
      >
        { busy === true ? 'Descargando' : `Descargar ${tipo}` }
      </LoadingButton>
    )
  }
}

export default RecepcionItemActions;